var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1033_12345)",
    filter: "url(#filter0_d_1033_12345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1523 30.6768C11.1511 35.2139 12.3458 39.644 14.6176 43.5487L10.9351 56.8901L24.6949 53.3102C28.5007 55.366 32.7649 56.4432 37.0981 56.4434H37.1094C51.4142 56.4434 63.0586 44.8935 63.0647 30.6971C63.0674 23.818 60.3699 17.3493 55.469 12.4826C50.569 7.61634 44.052 4.93496 37.1084 4.93182C22.802 4.93182 11.1584 16.4811 11.1525 30.6768",
    fill: "url(#paint0_linear_1033_12345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2257 30.6685C10.2242 35.3688 11.4618 39.9573 13.8146 44.0019L10 57.8215L24.2533 54.1133C28.1805 56.2379 32.6022 57.3581 37.1015 57.3597H37.1131C51.931 57.3597 63.9937 45.3943 64 30.6898C64.0025 23.5635 61.208 16.8623 56.132 11.8212C51.0554 6.78079 44.3054 4.00293 37.1131 4C22.2926 4 10.2318 15.9637 10.2259 30.6685H10.2257ZM18.7138 43.3053L18.1816 42.467C15.9444 38.9374 14.7636 34.8585 14.7653 30.6701C14.7701 18.4479 24.7947 8.50419 37.1215 8.50419C43.091 8.5067 48.7011 10.8157 52.9207 15.0051C57.1401 19.1949 59.4619 24.7645 59.4604 30.6881C59.4549 42.9103 49.4301 52.8553 37.1131 52.8553H37.1042C33.0936 52.8533 29.1603 51.7846 25.73 49.765L24.9137 49.2846L16.4555 51.485L18.7138 43.3051V43.3053Z",
    fill: "url(#paint1_linear_1033_12345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.393 19.5194C29.8897 18.4094 29.36 18.387 28.8814 18.3676C28.4895 18.3508 28.0415 18.3521 27.5939 18.3521C27.1458 18.3521 26.4179 18.5193 25.8026 19.1859C25.1866 19.8532 23.451 21.4657 23.451 24.7452C23.451 28.025 25.8585 31.1944 26.1941 31.6396C26.5301 32.084 30.8417 39.0295 37.6701 41.7014C43.3452 43.9219 44.5001 43.4803 45.7317 43.3689C46.9636 43.258 49.7067 41.7569 50.2663 40.2003C50.8263 38.6439 50.8263 37.3098 50.6584 37.031C50.4905 36.7533 50.0425 36.5865 49.3706 36.2533C48.6986 35.9199 45.3957 34.3072 44.78 34.0847C44.1641 33.8624 43.7162 33.7515 43.2682 34.419C42.8202 35.0854 41.5337 36.5865 41.1415 37.031C40.7498 37.4767 40.3577 37.5321 39.6861 37.1987C39.0138 36.8642 36.8502 36.1612 34.2833 33.8905C32.2862 32.1235 30.9379 29.9416 30.5459 29.2741C30.154 28.6077 30.504 28.2464 30.8408 27.9143C31.1427 27.6156 31.5129 27.1359 31.8491 26.7468C32.1841 26.3575 32.2959 26.0797 32.5199 25.6352C32.7441 25.1902 32.6319 24.8009 32.4642 24.4675C32.2959 24.134 30.9904 20.8375 30.393 19.5196",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1033_12345",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1033_12345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1033_12345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1033_12345",
    x1: 36.9999,
    y1: 56.8901,
    x2: 36.9999,
    y2: 4.93182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1033_12345",
    x1: 37,
    y1: 57.8215,
    x2: 37,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1033_12345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(10 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.51045e887a8a299bd3fd1a7981f315f6.svg";
export { ForwardRef as ReactComponent };